import React from 'react';
import { ChevronDown } from 'lucide-react';
import { footerColumns, footerTagline } from '../data/navigation';
const linkClass = 'hover:text-white transition-colors duration-150 rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal';
export function Footer() {
  return <footer className="bg-[#0A1F33] text-white/70 py-16 px-4 sm:px-6 lg:px-8 border-t border-white/10" data-id="element-1004" data-mp="36pza18ehm9h5">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8" data-id="element-1005" data-mp="3uftn9r2py01x">
        <div className="lg:col-span-4 lg:pr-8" data-id="element-1006" data-mp="387ddgpep1cm">
          <img src="https://cdn.magicpatterns.com/uploads/vBy52qowPNFNY53vkUADE7/SyNeural-logo-no-tagline-half-size.svg" alt="SyNeural" className="h-10 w-auto mb-5 brightness-0 invert" data-id="element-1007" data-mp="3lem0o69kenno" />
          <p className="text-sm leading-relaxed" data-id="element-1008" data-mp="29y5frxf8retf">{footerTagline}</p>
        </div>

        {/* Mobile: three collapsible groups */}
        <div className="sm:hidden divide-y divide-white/10 border-y border-white/10" data-id="element-1009" data-mp="2ezl0tphf5lbt">
          {footerColumns.map(column => <details key={column.heading} className="group" data-id="element-1010" data-mp="3gapbneqg0cdv">
              <summary className="flex cursor-pointer list-none items-center justify-between py-4 text-sm font-heading font-bold uppercase tracking-wider text-white [&::-webkit-details-marker]:hidden" data-id="element-1011" data-mp="3gca5f24xnrao">
                {column.heading}
                <ChevronDown size={16} aria-hidden="true" className="transition-transform duration-200 group-open:rotate-180" data-id="element-1012" data-mp="82qrjqil5pso" />
              </summary>
              <ul className="space-y-3 pb-5 text-sm" data-id="element-1013" data-mp="33e536vmmkqm">
                {column.links.map(link => <li key={`${column.heading}-${link.label}`} data-id="element-1014" data-mp="hsa8urqnhblf">
                    <a href={link.href} className={linkClass} data-id="element-1015" data-mp="ctgvr0f9zmls">
                      {link.label}
                    </a>
                  </li>)}
              </ul>
            </details>)}
        </div>

        {/* Tablet and desktop: three columns */}
        <div className="hidden sm:grid sm:grid-cols-3 gap-8 lg:col-span-8" data-id="element-1016" data-mp="tvcz5qtmo3em">
          {footerColumns.map(column => <nav key={column.heading} aria-label={`Footer: ${column.heading}`} data-id="element-1017" data-mp="ytejef2si8ro">
              <h2 className="text-white font-heading font-bold mb-5 uppercase tracking-wider text-sm" data-id="element-1018" data-mp="13tkde1wj87cx">{column.heading}</h2>
              <ul className="space-y-3 text-sm" data-id="element-1019" data-mp="18l2fitaakdzh">
                {column.links.map(link => <li key={`${column.heading}-${link.label}`} data-id="element-1020" data-mp="1cmdywh2ko2z8">
                    <a href={link.href} className={linkClass} data-id="element-1021" data-mp="1hkp4gflu3rbn">
                      {link.label}
                    </a>
                  </li>)}
              </ul>
            </nav>)}
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-14 pt-8 border-t border-white/10 text-xs flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-1022" data-mp="1rj4vkikv30l5">
        <p data-id="element-1023" data-mp="3od80iy1tdef4">&copy; {new Date().getFullYear()} SyNeural. All rights reserved.</p>
        <div className="flex gap-6" data-id="element-1024" data-mp="3tarq2u3ypdmd">
          <a href="/privacy" className={linkClass} data-id="element-1025" data-mp="2af3rznz78zik">
            Privacy Policy
          </a>
          <a href="/terms" className={linkClass} data-id="element-1026" data-mp="25of1aavcg6kh">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>;
}